<template>
  <div>
    <div style="overflow-x: auto; white-space: nowrap">
      <template v-for="option in dateOptions">
        <v-btn
          :key="option.value"
          class="ma-0 mr-1 mb-1"
          :depressed="filter == option.value"
          :outlined="filter != option.value"
          :color="filter == option.value ? 'primary' : 'grey'"
          small
          rounded
          @click="changeDate(option.value)"
          >{{ option.text }}</v-btn
        >
      </template>
    </div>

    <div v-if="filter == 'custom_date' || filter == 'custom_time'" class>
      <v-row>
        <v-col cols="12" sm="6">
          <span>{{ $t('from') }}:</span>
          <v-row>
            <v-col :cols="!showTime ? 12 : 8">
              <date-picker v-model="date.startdate" color="primary">
                <template #default="{ computedDate }">
                  <v-text-field
                    :data-vv-as="$t('from')"
                    :value="computedDate"
                    readonly
                    placeholder="DD/MM/YYYY"
                    hide-details
                    outlined
                    rounded
                    dense
                  ></v-text-field>
                </template>
              </date-picker>
            </v-col>
            <v-col v-if="showTime" cols="4">
              <time-picker v-model="date.starttime" color="primary">
                <v-text-field
                  v-model="date.starttime"
                  :data-vv-as="$t('time')"
                  readonly
                  placeholder="00:00"
                  hide-details
                  outlined
                  rounded
                  dense
                >
                </v-text-field>
              </time-picker>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <span>{{ $t('to') }}:</span>
          <v-row wrap row>
            <v-col :cols="!showTime ? 12 : 8">
              <date-picker v-model="date.enddate" color="primary">
                <template #default="{ computedDate }">
                  <v-text-field
                    :data-vv-as="$t('to')"
                    :value="computedDate"
                    readonly
                    placeholder="DD/MM/YYYY"
                    hide-details
                    outlined
                    rounded
                    dense
                  >
                  </v-text-field>
                </template>
              </date-picker>
            </v-col>
            <v-col v-if="showTime" cols="4">
              <time-picker v-model="date.endtime" color="primary">
                <v-text-field
                  v-model="date.endtime"
                  :data-vv-as="$t('time')"
                  readonly
                  placeholder="00:00"
                  hide-details
                  outlined
                  rounded
                  dense
                >
                </v-text-field>
              </time-picker>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn color="primary" small @click="onSearch">{{
            $t('Search')
          }}</v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from './DatePicker.vue'
import TimePicker from './TimePicker.vue'
export default {
  components: { DatePicker, TimePicker },
  props: {
    value: {
      default: {
        start: null,
        end: null
      }
    },
    currentFilter: {
      default: 'today'
    },
    avialableOptions: {
      default: ''
    },
    showTime: {
      default: false
    }
  },
  data() {
    return {
      filter: null,
      date: {
        startdate: null,
        enddate: null,
        starttime: null,
        endtime: null
      }
    }
  },
  computed: {
    dateOptions() {
      var options = [
        {
          value: 'today',
          text: this.$t('today')
        },
        {
          value: 'yesterday',
          text: this.$t('yesterday')
        },
        {
          value: 'last_3_days',
          text: this.$t('last {day} days', { day: 3 })
        },
        {
          value: 'last_7_days',
          text: this.$t('last {day} days', { day: 7 })
        },
        {
          value: 'last_15_days',
          text: this.$t('last {day} days', { day: 15 })
        },
        {
          value: 'last_month',
          text: this.$t('last {day} days', { day: 30 })
        },
        {
          value: 'last_365_day',
          text: this.$t('last {day} days', { day: 365 })
        },
        {
          value: 'this_month',
          text: this.$t('this_month')
        },
        {
          value: 'this_year',
          text: this.$t('this_year')
        },
        {
          value: 'custom_date',
          text: this.$t('Custom Date')
        }
      ]
      if (this.avialableOptions != '') {
        return options.filter((el) => {
          return this.avialableOptions.includes(el.value)
        })
      } else {
        return options
      }
    }
  },
  mounted() {
    let start, end, filter
    if (this.$route.query.filter) {
      if (
        this.$route.query.filter == 'custom_date' &&
        this.$route.query.start &&
        this.$route.query.end
      ) {
        start = moment(this.$route.query.start, 'YYYY-MM-DD HH:mm')
        end = moment(this.$route.query.end, 'YYYY-MM-DD HH:mm')
      }
      filter = this.$route.query.filter
    } else if (!this.value) {
      if (
        this.currentFilter == 'custom_date' &&
        this.value &&
        this.value.start &&
        this.value.end
      ) {
        start = moment(this.value.start, 'YYYY-MM-DD HH:mm')
        end = moment(this.value.end, 'YYYY-MM-DD HH:mm')
      }
      filter = this.currentFilter
    }
    this.changeDate(filter)
    if (filter == 'custom_date') {
      this.date.startdate = start ? start.format('YYYY-MM-DD') : null
      this.date.enddate = end ? end.format('YYYY-MM-DD') : null
      this.date.starttime = start ? start.format('HH:mm') : null
      this.date.endtime = end ? end.format('HH:mm') : null
      this.emitDateTime()
    }
  },
  methods: {
    onSearch() {
      this.emitDateTime()
    },
    changeDate(value) {
      this.filter = value
      if (value != 'custom_date') {
        var date = {
          start: moment(),
          end: moment()
        }
        switch (value) {
          case 'today':
            break
          case 'yesterday':
            date.start.subtract(1, 'days')
            date.end.subtract(1, 'days')
            break
          case 'this_month':
            date.start.startOf('month')
            date.end.endOf('month')
            break
          case 'last_3_days':
            date.start.subtract(3, 'days')
            break
          case 'last_7_days':
            date.start.subtract(7, 'days')
            break
          case 'last_15_days':
            date.start.subtract(15, 'days')
            break
          case 'last_month':
            date.start.subtract(1, 'months')
            break
          case 'this_year':
            date.start.startOf('year')
            date.end.endOf('year')
            break
          case 'last_365_day':
            date.start.subtract(365, 'days')
            break
          case 'custom_date':
            break
        }
        if (this.filter != 'custom_date') {
          this.$set(
            this.date,
            'startdate',
            date.start.format('YYYY-MM-DD 00:00')
          )
          this.$set(this.date, 'enddate', date.end.format('YYYY-MM-DD 23:59'))
          this.$set(this.date, 'starttime', '00:00')
          this.$set(this.date, 'endtime', '23:59')
        }
        this.emitDateTime()
      }
    },
    emitDateTime() {
      var data = {
        start:
          moment(this.date.startdate).format('YYYY-MM-DD') +
          (this.date.starttime != null && this.showTime
            ? ' ' + this.date.starttime
            : ' 00:00'),
        end:
          moment(this.date.enddate).format('YYYY-MM-DD') +
          (this.date.endtime != null && this.showTime
            ? ' ' + this.date.endtime
            : ' 23:59')
      }
      this.$emit('input', data)
      this.$emit('changeDate', data)
      var query = {}
      if (this.filter == 'custom_date') {
        query = {
          ...data
        }
      }
      query.filter = this.filter
      this.$router.push({ query: query }).catch(() => {
        //
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
